module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc16",
      "id": "dd16"
    }
  }, [_c('i', [_vm._v("January 14")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "amJanuary14"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0019-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("My Father is greater than I")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0019-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("W")]), _vm._v("hen you pray, say: Our Father in heaven. • My Father and your Father, and . . . My God and your God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-05-6"
    }
  }, [_vm._v("As the Father gave Me commandment, so I do. • The words that I speak to you I do not speak on My own authority; but the Father who dwells in Me does the works.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-05-7"
    }
  }, [_vm._v("The Father loves the Son, and has given all things into His hand. • You have given Him authority over all flesh, that He should give eternal life to as many as You have given Him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-05-8"
    }
  }, [_vm._v("“Lord, show us the Father, and it is sufficient for us.” Jesus said to him, “Have I been with you so long, and yet you have not known Me, Philip? He who has seen Me has seen the Father; so how can you say, ‘Show us the Father’? Do you not believe that I am in the Father, and the Father in Me?” • I and My Father are one. • As the Father loved Me, I also have loved you; abide in My love. If you keep My commandments, you will abide in My love, just as I have kept My Father’s commandments and abide in His love.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 14:28; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 11:2; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 20:17; 14:31; 14:10; 3:35; 17:2; 14:8–10; 10:30; 15:9–10")]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "aeJanuary14"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0019-08-11"
    }
  }, [_c('span', [_c('i', [_vm._v("He shall bruise your head, and you shall bruise His heel")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0019-09-13"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("H")]), _vm._v("is visage was marred more than any man, and His form more than the sons of men. • But He was wounded for our transgressions, He was bruised for our iniquities; the chastisement for our peace was upon Him, and by His stripes we are healed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-10-16"
    }
  }, [_vm._v("This is your hour, and the power of darkness. • You could have no power at all against Me unless it had been given you from above.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-10-17"
    }
  }, [_vm._v("The Son of God was manifested, that He might destroy the works of the devil. • [Jesus] . . . cast out many demons; and He did not allow the demons to speak, because they knew Him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-10-18"
    }
  }, [_vm._v("All authority has been given to Me in heaven and on earth. • Those who believe: In My name they will cast out demons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-10-19"
    }
  }, [_vm._v("The God of peace will crush Satan under your feet shortly.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(". 3:15; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 52:14; 53:5; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 22:53; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 19:11; 1 J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 3:8; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(" 1:34; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATT")]), _vm._v(". 28:18; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(" 16:17; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 16:20")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d884a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter16.vue
// module id = 111
// module chunks = 0